var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-cropper-container"},[_c('div',{staticClass:"image-container"},[_c('img',{ref:"originalImage",staticClass:"uploaded-image",attrs:{"src":_vm.uploadedImage,"alt":"image"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }